import $ from 'jquery';

$(function () {

  const productItem = $('.site-search__finder');

  $(".site-search .btn-search").on('click', function() {
    $(productItem).addClass('site-search__finder--active');
  });

  $(".site-search__finder .btn-close").on('click', function() {
    $(productItem).removeClass('site-search__finder--active');
  });

});